import { computed, ref } from "vue";
import { defineStore } from "pinia";
import {
  type AuthorizationEntityType,
  type UserAuthorizationEntry,
} from "@shared/types/common";

export const useAuthorizationStore = defineStore("authorization", () => {
  // State
  const _authorization = ref<UserAuthorizationEntry[] | null>(null);

  // Getters
  const authorization = computed(() => _authorization.value);

  const permissionsForEntity = (
    entityId: string,
    entityType: AuthorizationEntityType,
  ): ReadonlyArray<string> => {
    const entry = _authorization.value?.find(
      (authEntry) =>
        authEntry.entityId === entityId && authEntry.entityType === entityType,
    );
    return entry?.permissions ?? [];
  };

  const hasPermission = (
    entityId: string,
    permission: string,
    entityType: AuthorizationEntityType,
  ): boolean => {
    return permissionsForEntity(entityId, entityType).includes(permission);
  };

  // Actions
  const setAuthorization = (
    entries: ReadonlyArray<UserAuthorizationEntry> | null,
  ) => {
    _authorization.value = entries ? [...entries] : null;
  };

  const clearAuthorization = () => {
    _authorization.value = null;
  };

  return {
    authorization,
    permissionsForEntity,
    hasPermission,
    setAuthorization,
    clearAuthorization,
  };
});
